import { render, staticRenderFns } from "./StudentInfoDetail.vue?vue&type=template&id=32d4deac"
import script from "./StudentInfoDetail.vue?vue&type=script&lang=js"
export * from "./StudentInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports